import type { CompleteOnboardingDto } from '@shared/dto/onboarding/complete-onboarding.dto';
import { inject } from 'inversify';
import { Injectable } from '../../decorators/injectable';
import { HttpService, type IHttpService } from '../http/http.service';
import type { IOnboardingService, OnboardingStatus } from './onboarding.service.interface';

@Injectable()
export class OnboardingService implements IOnboardingService {
  constructor(@inject(HttpService) private readonly http: IHttpService) {}

  async getStatus(): Promise<OnboardingStatus> {
    return this.http.get<OnboardingStatus>('onboarding/status');
  }

  async complete(data: CompleteOnboardingDto): Promise<void> {
    await this.http.post('onboarding/complete', data);
  }
}
